import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('attribute-group');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    index() {
        return axios.$get('/admin/attribute-groups');
    }
};
